import React from 'react';
import { AvInput, AvGroup as BaseAvGroup } from 'availity-mobx-reactstrap-validation';
import styled from 'styled-components';

const QtyInput = styled(AvInput)`
  padding-left: 2rem;
  height: 3rem;
  font-size: 1.3rem;
  font-weight: 500;
  text-align: right;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`;


const AvGroup = styled(BaseAvGroup)`
  && {
    margin: 0;
  }
`;

export default props => (
  <AvGroup>
    <QtyInput {...props} />
  </AvGroup>
);
